module.exports = __webpack_public_path__ + "static/img/cdzy_image.2385c52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/cdzy_image.png
// module id = N1ZQ
// module chunks = 44